import React, { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

// project imports
import MainLayout from './../layout/MainLayout';
import Loadable from '../ui-component/Loadable';

// dashboard routing
const Jobs = Loadable(lazy(() => import('../views/dashboard/Jobs')));
const JobDetail = Loadable(lazy(() => import('../views/dashboard/Jobs/JobDetail')));
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard/Default')));
const JobTitles = Loadable(lazy(() => import('../views/dashboard/JobTitles')));
const NotFound = Loadable(lazy(() => import('../views/pages/NotFound')));

//-----------------------|| MAIN ROUTING ||-----------------------//

const MainRoutes = () => {
    const location = useLocation();

    return (
        <MainLayout>
            <Switch location={location} key={location.pathname}>
                <Route path="/dashboard/default" component={DashboardDefault} />
                <Route path="/dashboard/jobs/:postingId/:positionSlug" component={JobDetail} />
                <Route path="/dashboard/jobs" component={Jobs} />
                <Route path="/dashboard/job-titles" component={JobTitles} />
                <Route path="*" component={NotFound} />
            </Switch>
        </MainLayout>
    );
};

export default MainRoutes;
